import { render, staticRenderFns } from "./BitrixImage.vue?vue&type=template&id=92b7055c&scoped=true&functional=true"
import script from "./BitrixImage.vue?vue&type=script&lang=js"
export * from "./BitrixImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "92b7055c",
  null
  
)

export default component.exports